let React = require('react');
const FormatMessage = require('react-globalize').FormatMessage;

import PopularScams from './elderAbuseContent/PopularScams';
import Prevent from './elderAbuseContent/Prevent';
import WatchElderAbuse from './elderAbuseContent/watchElderAbuse';
import WhatIsElderAbuse from './elderAbuseContent/whatIsElderAbuse';

let SectionElderAbuse = React.createClass({

  render : function () {
    return(
      <div className="container" id="terms-cond-div" style={{ "marginTop": "5%", "marginBottom": "5%" }}>
        <div className="row" style={{ "marginTop": "3%", "marginBottom": "2%" }}>
          <h3 className="text-center">
            <FormatMessage locale={this.props.locale} path="footer/footerElderyFinancialAbuse" />
          </h3>
          <hr className="small-blue" />
        </div>

        <ul className="nav nav-tabs nav-fill nav-justified " id="myTab" role="tablist" style={{fontSize:"small"}}>
          <li className="nav-item active">
            <a className="nav-link active" id="whatIs-tab" data-toggle="tab" href="#whatIs" role="tab" aria-controls="whatIs" aria-selected="true">
              <FormatMessage locale={this.props.locale} path="elderAbuse/WhatIs" />
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" id="watch-tab" data-toggle="tab" href="#watch" role="tab" aria-controls="watch" aria-selected="false">
            <FormatMessage locale={this.props.locale} path="elderAbuse/Watch" />
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" id="popularScams-tab" data-toggle="tab" href="#popularScams" role="tab" aria-controls="popularScams" aria-selected="false">
            <FormatMessage locale={this.props.locale} path="elderAbuse/PopularScams" />
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" id="prevent-tab" data-toggle="tab" href="#prevent" role="tab" aria-controls="prevent" aria-selected="false">
            <FormatMessage locale={this.props.locale} path="elderAbuse/Prevent" />
            </a>
          </li>
        </ul>

        <div className="tab-content" id="myTabContent">
          <div className="tab-pane active" id="whatIs" role="tabpanel" aria-labelledby="whatIs-tab">
            <WhatIsElderAbuse locale={this.props.locale} />
          </div>
          <div className="tab-pane fade " id="watch" role="tabpanel" aria-labelledby="watch-tab">
            <WatchElderAbuse locale={this.props.locale} />
          </div>
          <div className="tab-pane fade" id="popularScams" role="tabpanel" aria-labelledby="popularScams-tab">
            <PopularScams locale={this.props.locale}/>
          </div>
          <div className="tab-pane fade" id="prevent" role="tabpanel" aria-labelledby="prevent-tab">
            <Prevent locale={this.props.locale} />
          </div>
        </div>

      </div>
    )
  }

})

export default SectionElderAbuse;


// WEBPACK FOOTER //
// ./js/sectionElderAbuse.js